import './buttons.css'

const Social = ({link, icon}) => {

      if(link === '') return 

      return (
            <a href={link} className="btn_social" targetr="_blank" rel="noreferrer">{icon}</a>
      )
}

export default Social
